import React from 'react';
import PropTypes from 'prop-types';
import GlobalMessages from '../../pages/Global/GlobalMessages';
import NotFound from '../NotFound/NotFound';
import Broadcast from '../../components/Broadcast';

export default class Default extends React.Component {
    static propTypes = {
        secondBar: PropTypes.func,
        profile: PropTypes.object,
        isProfileOwner: PropTypes.bool,
    };

    render() {
        const secondbar = this.props.secondBar && (
            <this.props.secondBar {...this.props} />
        );

        const notFound = this.props.profile?.error?.status === 404;

        const content = notFound ? <NotFound /> : this.props.children;

        return (
            <React.Fragment>
                <Broadcast />
                {secondbar}
                {content}
                <GlobalMessages />
            </React.Fragment>
        );
    }
}
